import { render, staticRenderFns } from "./PushNotification.vue?vue&type=template&id=7522bd08&"
import script from "../../models/analysis/push-notification.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/push-notification.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports